import Vue from 'vue'
import store from '@/store'

const panel = new Vue({
  store,
  computed: {
    visible() {
      return !!this.$store.state.panel.panels.length
    },
  },

  methods: {
    close(componentPath) {
      this.$store.commit('panel/CLOSE', componentPath)
    },

    closeAll(componentPath) {
      this.$store.commit('panel/CLOSE_ALL')
    },

    open(componentPath, props = {}) {
      this.$store.commit('panel/OPEN', { componentPath: componentPath, props: props })
    },
  },
})

export default {
  install: function(Vue) {
    Vue.panel = panel
    Vue.prototype.$panel = panel
  },
}
